import type { TabType } from "./types"

// The comment editor is lazily created and stays display:none until the tab
// switch commits, so focusing before either lands is a silent no-op.
export function shouldFocusCommentEditor({
	pendingFocus,
	activeTab,
	hasCommentEditor,
}: {
	pendingFocus: boolean
	activeTab: TabType
	hasCommentEditor: boolean
}): boolean {
	return pendingFocus && activeTab === "comment" && hasCommentEditor
}
